import { render } from "./LectureScreen.vue?vue&type=template&id=4864f176&scoped=true"
import script from "./LectureScreen.vue?vue&type=script&lang=js"
export * from "./LectureScreen.vue?vue&type=script&lang=js"

import "./LectureScreen.vue?vue&type=style&index=0&id=4864f176&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4864f176"]])

export default __exports__